import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalVariable } from 'app/main/globals';

@Injectable({
  providedIn: 'root'
})
export class AspWebsiteSettingService {

  constructor(
    private http: HttpClient
  ) { }

 submit(payload: any){
    const paramData=payload;
    return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}/garage/garageWeb`, paramData);
  }

  
  submitInsuranceCompaniesList(){
    return this.http.get(`${GlobalVariable.BASE_API_URL_SPARES}/garage/insuranceCompanies`);
  }

  roleTypeList(){
    return this.http.get(`${GlobalVariable.BASE_API_URL_SPARES}/garage/garagePersonRoles`);
  }
  // https://iapi.testpitstop.com/v1.0/pitstopspare/garage/garagePersonRoles
}
